import type { TaskPriority, TaskStatus } from '../api/tasks';
import { t } from '../i18n';

/** Labels and date formatting shared by the task list and the task page. */

export const statusLabel = (s: TaskStatus): string => t(`tasks.status.${s}`);
export const priorityLabel = (p: TaskPriority): string => t(`tasks.priority.${p}`);
export const priorityClass = (p: TaskPriority): string => (p === 'urgent' ? 'badge danger' : p === 'high' ? 'badge warn' : 'badge');

const two = (n: number) => String(n).padStart(2, '0');
const hm = (d: Date) => `${two(d.getHours())}:${two(d.getMinutes())}`;
const dm = (d: Date) => `${two(d.getDate())}.${two(d.getMonth() + 1)}`;
const dmy = (d: Date) => `${dm(d)}.${d.getFullYear()}`;

function sameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/** "сьогодні 10:15", "вчора 18:40", "03.09 11:20" (same year) or "03.09.2025 11:20". */
export function fmtWhen(iso: string | null | undefined, withTime = true): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const time = withTime ? ` ${hm(d)}` : '';
  if (sameDay(d, now)) return `${t('task.today')}${time}`;
  if (sameDay(d, yesterday)) return `${t('task.yesterday')}${time}`;
  return `${d.getFullYear() === now.getFullYear() ? dm(d) : dmy(d)}${time}`;
}

/** Due dates: "12.09" in the list, "12.09.2026" on the task page. */
export function fmtDue(iso: string | null | undefined, full = false): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return full ? dmy(d) : dm(d);
}

/** ISO → value for <input type="date"> in local time. */
export function toDateInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}`;
}
